export default __webpack_public_path__ + "24a7a5ad2ab2c75fd94aeeaf81a7d9da.png";